module.exports = __webpack_public_path__ + "static/img/operateMonth.673ab8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateMonth.png
// module id = MPHe
// module chunks = 1